module.exports = __webpack_public_path__ + "img/430-47f146.png";